<template>
  <div class="product_form_list__item">
    <div class>
      <div class="level">
        <h3 class="product_form_list__title">
          {{ productFormItem.name }} ({{ productFormItem.position }})
        </h3>
        <div>
          <b-button
            @click="isImageModalActive3 = true"
            type="is-dark mr-1"
            size="is-small"
          >
            <font-awesome-icon :icon="['fas', 'plus']" />
            Agregar Opciones
          </b-button>
          <b-button
            type="mr-1"
            size="is-small"
            @click="isImageModalActive1 = true"
          >
            <font-awesome-icon :icon="['fas', 'edit']" />
          </b-button>
          <b-button
            type="is-danger"
            size="is-small"
            @click="isImageModalActive2 = true"
          >
            <font-awesome-icon :icon="['fas', 'trash']" />
          </b-button>
        </div>
      </div>
      <hr />
      <div class v-if="productFormItem.options.length > 0">
        <ProductFormOptionItem
          :product-form-option-item="opt"
          v-for="opt in productFormItem.options"
          :key="opt.id"
          @productFormOptionUpdate="productFormOptionUpdate"
        ></ProductFormOptionItem>
      </div>
      <small v-else>No cuenta con opciones</small>
    </div>
    <hr />
    <b-modal :width="550" scroll="keep" v-model="isImageModalActive2">
      <div class="card">
        <div class="card-content py-5">
          <h3 class="is-size-4 has-text-weight-bold mb-5">
            Eliminar Grupo de Opción {{ form.name }}
          </h3>
          <hr />
          <div
            class="is-flex is-justify-content-flex-end w-full is-align-items-center"
          >
            <div>
              <Button
                variant="gray"
                @click.native="isImageModalActive2 = false"
                >Cancelar</Button
              >
            </div>
            <div class="ml-3">
              <Button
                variant="danger"
                :spinner="loading"
                @click.native="deleteProductForm"
                >Sí</Button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="isImageModalActive1" :width="468" scroll="keep">
      <div class="card">
        <div class="card-content py-5">
          <h3 class="is-size-4 has-text-weight-bold mb-5">
            Actualizar Grupo de Opciones
          </h3>
          <hr />
          <div>
            <b-field label="Activo">
              <b-switch v-model="form.is_active" type="is-success"></b-switch>
            </b-field>
            <b-field
              label="Nombre del área"
              :custom-class="$v.form.name.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.form.name.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.form.name.required && $v.form.name.$error
                }
              ]"
            >
              <b-input v-model="form.name"></b-input>
            </b-field>
            <b-field
              label="Texto de ayuda"
              :custom-class="$v.form.help_text.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.form.help_text.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.form.help_text.required && $v.form.help_text.$error
                }
              ]"
            >
              <b-input v-model="form.help_text"></b-input>
            </b-field>
            <b-field
              label="Posición"
              :custom-class="$v.form.position.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.form.position.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.form.position.required && $v.form.position.$error
                }
              ]"
            >
              <b-input v-model="form.position" type="number" min="0"></b-input>
            </b-field>
            <b-field label="Obligatorio">
              <b-switch v-model="form.mandatory" type="is-success"></b-switch>
            </b-field>
            <b-field label="Tipo de opción">
              <b-select
                placeholder="Seleccione una opción"
                expanded
                v-model="form.type_option"
              >
                <!-- <option value="B">
                  Elección Switch
                </option> -->
                <option value="Q">
                  Elección Cantidad
                </option>
                <option value="R">
                  Elección Única
                </option>
                <option value="C">
                  Elección Multiple
                </option>
              </b-select>
            </b-field>
          </div>
          <hr />
          <div v-if="form.type_option != 'B' && form.type_option != 'R'">
            <b-field label="Cantidad Mínima">
              <b-input
                type="number"
                min="0"
                v-model="form.min_quantity"
              ></b-input>
            </b-field>
            <b-field label="Cantidad Máxima">
              <b-input type="number" min="0" v-model="form.max_quantity">
              </b-input>
            </b-field>
            <hr />
          </div>
          <div
            class="is-flex is-justify-content-flex-end w-full is-align-items-center"
          >
            <div>
              <Button
                variant="gray"
                @click.native="isImageModalActive1 = false"
                >Cerrar</Button
              >
            </div>
            <div class="ml-3">
              <Button
                variant="main"
                :spinner="loading"
                @click.native="submitProductForm"
                >Actualizar</Button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="isImageModalActive3" :width="468" scroll="keep">
      <div class="card">
        <div class="card-content py-5">
          <h3 class="is-size-4 has-text-weight-bold mb-5">
            Crear Opciones
          </h3>
          <hr />
          <div>
            <b-field label="Activo">
              <b-switch v-model="option.is_active" type="is-success"></b-switch>
            </b-field>
            <b-field label="Sugerido">
              <b-switch v-model="option.suggested" type="is-success"></b-switch>
            </b-field>
            <b-field
              label="Position"
              :custom-class="$v.option.position.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.option.position.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.option.position.required && $v.option.position.$error
                }
              ]"
            >
              <b-input
                v-model="option.position"
                type="number"
                min="0"
              ></b-input>
            </b-field>
          </div>
          <div class="form-group form-row">
            <b-field label="Producto"></b-field>
            <div class="bv-no-focus-ring col">
              <multiselect
                v-model="option.product"
                :options="product_list"
                label="name"
                track-by="id"
                :searchable="true"
                :loading="isLoadingSearch"
                placeholder="Buscar"
                @search-change="getProductList"
                @select="changeProduct"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="true"
                :options-limit="300"
                :limit="3"
              >
                <template slot="tag" slot-scope="{ option, remove }">
                  <span class="custom__tag">
                    <span>{{ option.name }}</span>
                    <span class="custom__remove" @click="remove(option)"
                      >❌</span
                    >
                  </span>
                </template>

                <span slot="noResult">No se encontaron coincidencia</span>
              </multiselect>
            </div>
          </div>
          <div v-if="option.product">
            <hr />
            <b-field
              label="Nombre"
              :custom-class="$v.option.name.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.option.name.$error }"
              :message="[
                {
                  'Campo requerido':
                    !$v.option.name.required && $v.option.name.$error
                }
              ]"
            >
              <b-input v-model="option.name"></b-input>
            </b-field>
            <b-field
              label="Precio"
              :custom-class="$v.option.price.$error ? 'has-text-danger' : ''"
              :type="{ 'is-danger': $v.option.price.$error }"
              :message="[{ 'Campo requerido': !$v.option.price.required }]"
            >
              <b-input v-model="option.price"></b-input>
            </b-field>
          </div>
          <hr />
          <div
            class="is-flex is-justify-content-flex-end w-full is-align-items-center"
          >
            <div>
              <Button
                variant="gray"
                @click.native="isImageModalActive3 = false"
                >Cerrar</Button
              >
            </div>
            <div class="ml-3">
              <Button
                variant="main"
                :spinner="loading"
                @click.native="submitProductFormOption"
                >Crear</Button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { required, decimal } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import ErrorsDJ from '@/mixins/error'
import ProductFormOptionItem from '@/components/product/ProductFormOptionItem'
import Button from '@/components/form/Button'
import ProductService from '@/services/ProductService'
export default {
  name: 'ProductFormItem',
  props: ['productFormItem'],
  mixins: [ErrorsDJ],
  components: {
    Multiselect,
    ProductFormOptionItem,
    Button
  },
  data() {
    return {
      loading: null,
      loadingDelete: null,
      form: {
        name: this.productFormItem.name,
        mandatory: this.productFormItem.mandatory,
        max_quantity: this.productFormItem.max_quantity,
        min_quantity: this.productFormItem.min_quantity,
        type_option: this.productFormItem.type_option,
        position: this.productFormItem.position,
        is_active: this.productFormItem.is_active,
        help_text: this.productFormItem.help_text
      },
      option: {
        product: null,
        name: '',
        suggested: false,
        price: '',
        position: 1,
        is_active: true
      },
      product_list: [],
      isLoadingSearch: false,
      isImageModalActive1: false,
      isImageModalActive2: false,
      isImageModalActive3: false
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      help_text: {
        required
      },
      position: {
        required
      }
    },
    option: {
      position: {
        required
      },
      name: {
        required
      },
      price: {
        required,
        decimal
      },
      producto: {
        required
      }
    }
  },
  methods: {
    async getProductList(query) {
      this.isLoadingSearch = true
      const params = {
        query: query,
        id: this.$route.params.id
      }
      const reponse = await ProductService.getFormItem(params)
      this.product_list = reponse.data
      this.isLoadingSearch = false
    },

    async deleteProductForm() {
      this.loadingDelete = true
      try {
        const response = await ProductService.deleteForm(
          this.$route.params.id,
          this.productFormItem.id
        )
        this.loadingDelete = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se eliminó correctamente'
        })
        this.$emit('productFormUpdate', response.data)
        this.isImageModalActive2 = false
      } catch (error) {
        this.loadingDelete = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    },
    async submitProductForm() {
      this.cleanErrors()
      this.loading = true
      try {
        const response = await ProductService.putForm(
          this.$route.params.id,
          this.productFormItem.id,
          this.form
        )
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se actualizó correctamente'
        })
        this.$emit('productFormUpdate', response.data)
        this.isImageModalActive2 = false
      } catch (error) {
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    },
    changeProduct(value) {
      if (value) {
        this.option.name = value.name
        this.option.price = value.price
      }
    },
    productFormOptionUpdate() {
      this.$emit('productFormUpdate', {})
    },
    async submitProductFormOption() {
      this.$v.$touch()
      this.loading = true
      const optionCustom = {}
      Object.assign(optionCustom, this.option)
      if (optionCustom.product) {
        optionCustom.product = optionCustom.product.id
      }
      try {
        const response = await ProductService.postFormOption(
          this.productFormItem.id,
          optionCustom
        )
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se guardó correctamente.'
        })
        this.$emit('productFormUpdate', response.data)
        this.isImageModalActive3 = false
      } catch (error) {
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    }
  }
}
</script>
<style lang="scss">
.product_form_list__header {
  border-bottom: 1px solid black;
  padding-bottom: 5px;
}
.product_form_list__title {
  font-size: 14px;
  color: black;
  margin-bottom: 0;
}
//
// Select2.scss
//
@import '~vue-multiselect/dist/vue-multiselect.min.css';

.multiselect__tags {
  padding-bottom: 0.5rem !important;
  padding-top: 0.8rem !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  background-color: $color-white;
  border: 1px solid $color-gray;
  font-weight: 300;
  color: $color-black;
}
.multiselect__placeholder {
  padding-top: 0 !important;
  margin-bottom: 0 !important;
  color: $color-gray;
}
.multiselect__input {
  margin-bottom: 0 !important;
}
.multiselect__single {
  padding-left: 0 !important;
  margin-bottom: 0 !important;
}
.multiselect__tag {
  background-color: $color-main !important;
  margin-bottom: 0 !important;
}

.multiselect__tag-icon:after {
  color: $color-gray !important;
}

.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: 15px !important;
}

.multiselect__input,
.multiselect__single {
  background-color: $color-white !important;
}

.multiselect__content-wrapper {
  background-color: $color-white !important;
  border: 1px solid $color-gray !important;
}

.mx-input::placeholder {
  color: $color-black;
}

.multiselect__input,
.mx-calendar-icon,
.mx-datepicker-btn-confirm,
.multiselect__option {
  color: $color-black !important;
}

.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: $color-main !important;
  color: $color-white !important;
}
</style>
